import Maths3 from "oc-threejs/Maths3.js";
import Restraint from "./Restraint.js";
import Scenes from "oc-threejs/Scenes";
import {v3} from "oc-threejs/short3";
import Debugs from "oc-threejs/Debugs";
import AnchorAwareMixin from "./AnchorAwareMixin";
import OcAxisHelper from "oc-threejs/objects/OcAxisHelper";

class PlaneRestraintIntern extends Restraint {
    /**
     * @param {THREE.Ray} ray
     * @returns {?THREE.Vector3}
     */
    raycastLocal(ray) {
        return ray.intersectPlane(this.plane);
    }
}

/**
 * Positioniert das Objekt direkt über einer beliebigen Ebene (default Boden = y-Ebene, oder an einer "Wand").
 * Wenn das Objekt keinen Anchor hat, dann wird das Objekt mit der Unterseite der Boundingbox auf die Ebene gesetzt.
 * Ansonsten wird der Anchor auf die Ebene gesetzt.
 */
export default class PlaneRestraint extends AnchorAwareMixin(PlaneRestraintIntern) {

    /** @type {THREE.Plane} */
    plane;
    // @deprecated synonym für options.freeOrientation
    /** @type {boolean} */
    freeOrientationAroundMainAxis;
    /** @type {THREE.Vector3} */
    defaultAnchorBoxPosition;

    constructor(options = {}) {
        super(options);
        this.plane = options.plane || Maths3.plane.y0;
        this.freeOrientation = options.freeOrientation || options.freeOrientationAroundMainAxis || false;
        this.defaultAnchorBoxPosition = options.defaultAnchorBoxPosition || this.plane.normal?.clone().multiplyScalar(-0.5);
        this.box = options.box;
    }

    /**
     * @param {THREE.Raycaster} raycaster
     * @param {THREE.Vector3} point
     * @param {boolean} dropped
     */
    perform(raycaster, point, dropped) {
        if (this.freeOrientation) {
            Scenes.bring({
                what: [this.dragObject3d,this.anchorMatrix,v3(0,1,0)],
                to: [this.matrixWorld,this.plane.normal],
                rotate: true,
            });
        } else {
            Scenes.bring({
                what: [this.dragObject3d,this.anchorMatrix],
                to: [this.matrixWorld],
                rotate: true,
            });
        }

        // box beisst sich mit PlaneInBoxRestraint... wäre besser gewesen dafür einen eigenen Restraint zu machen
        // statt das hier in PlaneRestraint...
        if(this.box) {
            console.warn('PlaneRestraint.box is deprecated, please make and use a custom Restraint inherited from PlaneRestraint for this');
            const objectBox = this.getObjectBox(this.dragObject3d);
            const box = this.box.clone();
            box.expandByVector(objectBox.getSize().multiplyScalar(-0.5));
            point = box.clampPoint(point);
            // point.x = THREE.MathUtils.clamp(point.x, validPoint.minX, validPoint.maxX);
            // point.z = THREE.MathUtils.clamp(point.z, validPoint.minZ, validPoint.maxZ);
            // Scenes.bring({
            //     what: [this.dragObject3d,this.anchorMatrix],
            //     to: [point],
            //     translate: true,
            // });
        }

        Scenes.bring({
            what: [this.dragObject3d,this.anchorMatrix],
            to: [point],
            translate: true,
        });

    }

    getObjectBox(dragged, box3) {
        let objectBB = new THREE.Box3();
        return objectBB.expandByObject(dragged);
    }

    setDefaultAnchorMatrix() {
        // setze das Objekt mittig auf den Boden
        const size = this.dragObject3dBoundingBoxLocal.getSize();
        this.anchorMatrix = new THREE.Matrix4().setPosition(size.multiply(this.defaultAnchorBoxPosition));
    }

    createDebugVisualization() {
        const group = new THREE.Group();
        group.add(new OcAxisHelper(1));
        const color = STAGE.settings.dragDrop.restraintsDebugColor;
        const grid = new THREE.GridHelper( 10, 50, color, color );
        grid.quaternion.copy(new THREE.Quaternion().setFromUnitVectors(Maths3.vector.y,this.plane.normal));
        group.add(grid);
        return group;
    }

}
